var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurple360Tablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 116,
    viewBox: "0 0 672 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 672,
    height: 116
  }, /*#__PURE__*/React.createElement("rect", {
    width: 672,
    height: 116,
    rx: 16,
    fill: "#190033"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M701.23 14.8436C750.254 14.24 823.544 5.09283 831.188 21.917C838.969 38.8237 781.104 81.7018 750.687 114.696C720.271 147.69 717.18 170.816 705.365 211.375C693.427 251.951 672.778 310.059 638.623 322.872C604.468 335.686 556.808 303.205 515.722 275.079C474.5 246.87 439.865 223.115 418.279 191.735C396.679 160.256 388.276 121.332 406.072 91.7684C423.881 62.3034 468.011 42.1809 505.022 28.3741C542.033 14.5672 572.047 7.05927 599.618 7.25035C627.066 7.45805 652.083 15.4638 701.23 14.8436Z",
    fill: "#B2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M750.319 18.9671C789.686 25.0103 849.437 25.816 853.733 43.6434C858.13 61.5714 807.072 96.521 779.095 125.327C751.118 154.132 746.122 176.794 732.234 215.672C718.245 254.55 695.364 309.744 666.588 317.902C637.811 326.06 603.14 287.183 573.265 253.542C543.289 219.801 518.11 191.399 504.222 157.154C490.333 122.809 487.835 82.8232 505.321 55.7297C522.806 28.7369 560.375 14.6362 591.55 5.87362C622.724 -2.88895 647.603 -6.31341 669.685 -2.38536C691.667 1.5427 710.851 12.924 750.319 18.9671Z",
    fill: "#B2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M550.341 360.638C587.05 376.158 638.415 406.79 651.346 393.962C664.416 381.101 639.052 324.781 630.174 285.754C621.295 246.726 628.818 224.94 637.188 184.776C645.473 144.56 654.659 85.8826 634.365 63.9011C614.071 41.9195 564.296 56.6341 521.333 69.4321C478.233 82.2629 441.998 93.0919 412.352 114.779C382.654 136.552 359.735 169.065 360.559 201.146C361.434 233.141 386.136 264.757 408.161 288.507C430.186 312.256 449.619 328.191 470.489 336.441C491.274 344.639 513.548 345.066 550.341 360.638Z",
    fill: "#B2E7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple360Tablet);
export default __webpack_public_path__ + "static/media/Purple360Tablet.ab56b10a19bc7aa6d49c116638d720a6.svg";
export { ForwardRef as ReactComponent };